import { Pipe, PipeTransform } from '@angular/core';
import { FinancialUtilsService } from '../../core/services';


/**
 * Converts a large number to a short version with a suffix provided by the {@Link FinancialUtilsService}
 * If currency is passed as argument, sets the currency symbol in its wide version
 */
@Pipe({
    name: 'rmsFormatMoney',
    standalone: false
})
export class RmsFormatMoneyPipe implements PipeTransform {
  transform(value: any, currency?: any, decimal?: number): string {
    if (value === null) {
      return value;
    }
    if (currency) {
      return `${FinancialUtilsService.convertMoneyCurrency(value, currency, decimal)}`;
    }
    return FinancialUtilsService.convertMoney(value, decimal);
  }

}
